export default class Locale_OverviewDefaultOptions {
	ItemsOverview: string = "Items Overview";
	Item: string = "Item";
	SearchItems: string = "Search items";
}